/**
 * Build MQTT SyncTimerGroup payload.
 * - enable: group on/off (legacy boards apply to all 12 slots)
 * - arm1~arm12: per-slot arm (new firmware; ignored by old)
 * When enable=0, armN are forced to 0 so new FW stays off after Enable.
 */
export function buildTimerGroupMqttPayload({ enable, days, data }) {
  const mqttPayload = { enable: enable ? 1 : 0 };
  if (days !== undefined && days !== null) {
    mqttPayload.days = days;
  }
  (data || []).forEach((item, i) => {
    const n = i + 1;
    mqttPayload[`scheduledtime${n}`] = item.start;
    mqttPayload[`scheduledTemp${n}`] = item.temp;
    mqttPayload[`scheduledPattern${n}`] = item.pattern ?? 0;
    const slotOn = item.enabled === false ? 0 : 1;
    mqttPayload[`arm${n}`] = enable ? slotOn : 0;
  });
  return mqttPayload;
}

export function weekToDaysMask(week) {
  return (week || []).map((item, i) => (item ? ['S', 'M', 'T', 'W', 'T', 'F', 'S'][i] : '-')).join('');
}
